import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  activeSchemaIdSelector,
  significanceErrorSelector,
  significanceMetricSelector,
} from '../../../../../redux/selectors/builder';
import {
  ISearchCohortEntityFieldsFragment,
  MetricTypeKey,
  QueryType,
} from '../../../../../utils/apollo/graphqlSchema';
import { setSignificanceRetentionReport } from '../../../../../redux/slices/oldBuilder';
import { assertCondition } from '../../../../../utils/types';
import { BuilderReportMenu } from '../../../../../components/Builder/BuilderFields';

const SignificanceRetentionMetric = () => {
  const dispatch = useAppDispatch();

  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const significanceMetric = useAppSelector(significanceMetricSelector);
  assertCondition(significanceMetric?.type === MetricTypeKey.Retention);
  const { analysisId } = significanceMetric;

  const hasError = useAppSelector((state) =>
    significanceErrorSelector(state, 'metricAnalysis'),
  );

  const handleChange = (analysis: ISearchCohortEntityFieldsFragment | null) => {
    if (!analysis) {
      dispatch(
        setSignificanceRetentionReport({
          analysisId: null,
        }),
      );
    } else {
      assertCondition(analysis.__typename === 'Retention');

      const { id } = analysis;

      dispatch(
        setSignificanceRetentionReport({
          analysisId: id,
        }),
      );
    }
  };

  return (
    <BuilderReportMenu
      activeSchemaId={activeSchemaId}
      analysisId={analysisId}
      queryType={QueryType.Retention}
      onChange={handleChange}
      placeholder={'Search and select Retention'}
      hasError={hasError}
    />
  );
};

export default SignificanceRetentionMetric;
